import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const createSubscription: ThemeApp['appComponents']['createSubscription'] = {
  subscriptionTypes: {
    pro: {
      steps: {
        components: {
          reviewAndCreate: {
            components: {
              costsAndPayment: {
                costsAndPayment: {
                  hr: {
                    backgroundColor: themeUi.semantic.color.background.neutral500
                  },
                  explanationText: {
                    color: themeUi.semantic.color.text.neutral600
                  }
                },

                components: {
                  applyCoupon: {
                    couponContainer: {
                      backgroundColor: themeUi.semantic.color.background.secondary50,
                      dividerColor: themeUi.semantic.color.background.secondary300
                    },
                    couponTitle: {
                      color: themeUi.semantic.color.text.neutral800
                    }
                  },

                  blockTitle: {
                    hr: {
                      backgroundColor: themeUi.semantic.color.background.neutral500
                    }
                  },

                  totalSubPrice: {
                    darkBlueTextColor: {
                      color: themeUi.semantic.color.text.neutral800
                    },
                    perMonthText: {
                      color: themeUi.semantic.color.text.neutral600
                    }
                  }
                }
              },

              databasesTable: {
                wrappedTable: {
                  borderTop: themeUi.semantic.color.border.neutral300
                }
              },

              subscriptionProperties: {
                propertyRow: {
                  color: themeUi.semantic.color.text.neutral700
                }
              },

              vendorDetailsAndName: {
                leftSection: {
                  backgroundColor: themeUi.semantic.color.background.secondary300
                },
                inputInnerContainer: {
                  backgroundColor: themeUi.semantic.color.background.secondary300
                },
                sharedLabelsStyle: {
                  color: themeUi.semantic.color.text.neutral700
                },
                valueText: {
                  color: themeUi.semantic.color.text.neutral800
                }
              }
            }
          },

          setup: {
            components: {
              advancedOptions: {
                components: {
                  availabilityZone: {
                    labelText: {
                      color: themeUi.semantic.color.text.secondary950
                    }
                  },

                  cloudAccountSelect: {
                    title: {
                      color: themeUi.semantic.color.text.secondary950
                    }
                  },

                  autoTiering: {
                    title: {
                      color: themeUi.semantic.color.text.secondary950
                    },
                    description: {
                      color: themeUi.semantic.color.text.secondary600
                    }
                  },

                  multiAz: {
                    title: {
                      color: themeUi.semantic.color.text.secondary950
                    },
                    description: {
                      color: themeUi.semantic.color.text.secondary600
                    }
                  },

                  vpcConfiguration: {
                    title: {
                      color: themeUi.semantic.color.text.secondary950
                    },
                    sectionHeader: {
                      color: themeUi.semantic.color.text.secondary600
                    }
                  }
                }
              },

              multiSelectRegions: {
                regionDisplayField: {
                  color: themeUi.semantic.color.text.primary600
                }
              }
            }
          },

          sizing: {
            sizing: {
              wrappedTable: {
                borderTop: themeUi.semantic.color.border.neutral300
              }
            },

            components: {
              newDatabaseForm: {
                newDatabaseForm: {
                  divider: {
                    backgroundColor: themeUi.semantic.color.background.secondary300
                  }
                },

                components: {
                  optimizeProModal: {
                    components: {
                      optimizeRecommendations: {
                        text: {
                          color: themeUi.semantic.color.text.neutral600
                        }
                      }
                    },
                    optimizedValuesTitle: {
                      color: themeUi.semantic.color.text.neutral800
                    }
                  },

                  aaForm: {
                    hrDark: {
                      borderTop: themeUi.semantic.color.border.secondary300
                    }
                  },

                  advancedCapabilities: {
                    headerNoticeMessage: {
                      color: themeUi.semantic.color.text.neutral600,
                      fontSize: themeUi.core.font.fontSize.s12
                    },
                    recommendedText: {
                      color: themeUi.semantic.color.text.neutral700,
                      fontSize: themeUi.core.font.fontSize.s14
                    },
                    advancedCapabilitiesTitle: {
                      color: themeUi.semantic.color.text.neutral800,
                      fontSize: themeUi.core.font.fontSize.s16
                    }
                  },
                  midSection: {
                    hashingPolicy: {
                      hashingPolicyConfiguration: {
                        tooltip: {
                          color: themeUi.semantic.color.text.neutral800
                        }
                      },
                      components: {
                        hashingPolicySelection: {
                          popover: {
                            color: themeUi.semantic.color.text.neutral800
                          }
                        }
                      }
                    }
                  },

                  moreOptions: {
                    verticalDivider: {
                      backgroundColor: themeUi.semantic.color.background.secondary300
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  components: {
    cloudAndRegionSelection: {
      components: {
        creationRegionSelect: {
          creationRegionSelect: {
            title: {
              color: themeUi.semantic.color.text.neutral700
            },
            selectContentBottom: {
              borderTop: themeUi.semantic.color.border.secondary300
            }
          },

          components: {
            newRedisOptInToggle: {
              text: {
                enabledColor: themeUi.semantic.color.text.neutral700,
                disabledColor: themeUi.semantic.color.text.neutral500
              }
            },

            renderRegionItem: {
              optInText: {
                color: themeUi.semantic.color.text.neutral600
              }
            }
          }
        }
      }
    }
  }
};

export default createSubscription;
